import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
} from "@mui/material";
import SearchBar from "../../../components/SearchBar";
import SetHealthScore from "../../../Modals/setHealthScore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const automationData = [
  {
    id: 1,
    name: "Compliance & Trust",
    score: 25,
    metrics: [
      "Trade license validity",
      "Required documents",
      "Policy acceptance",
      "Violations",
      "Risk flags",
    ],
  },
  {
    id: 2,
    name: "Order & Fulfillment Performance",
    score: 25,
    metrics: [
      "Order fulfillment rate",
      "On-time shipment",
      "Cancellation rate",
      "Return rate (vendor fault)",
      "SLA breaches",
    ],
  },
  {
    id: 3,
    name: "Customer Experience",
    score: 20,
    metrics: [
      "Average rating",
      "Review volume",
      "Complaint rate",
      "Response time",
      "Dispute outcomes",
    ],
  },
  {
    id: 4,
    name: "Financial Reliability",
    score: 15,
    metrics: [
      "Failed payouts",
      "Refund ratio",
      "Chargebacks",
      "VAT compliance",
      "Outstanding balances",
    ],
  },
  {
    id: 5,
    name: "Engagement & Store Quality",
    score: 15,
    metrics: [
      "Active products",
      "Stock availability",
      "Content quality",
      "Store completeness",
      "Activity level",
    ],
  },
];

function ManageAutomation() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [expandedRow, setExpandedRow] = useState<number | null>(null);

  return (
    <>
      <div className="main_title">
        <h1>Manage Automation</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/vendor-health-score")}>
            Vendor Health Scores
          </button>{" "}
          - Manage Automation
        </p>
      </div>

      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search automation..."
            />
          </div>

          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              Set Health Score
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Automation Name</TableCell>
                <TableCell>Score</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {automationData.map((row, index) => (
                <React.Fragment key={row.id}>
                  <TableRow hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.score}%</TableCell>
                    <TableCell>
                      <Button
                        className="btn btn_primary sm"
                        onClick={() =>
                          setExpandedRow(
                            expandedRow === row.id ? null : row.id
                          )
                        }
                      >
                        {expandedRow === row.id ? (
                          <>
                            <ExpandLessIcon /> Hide
                          </>
                        ) : (
                          <>
                            <ExpandMoreIcon /> View
                          </>
                        )}
                      </Button>
                    </TableCell>
                  </TableRow>

                  {/* Expanded Metrics Section */}
                  {expandedRow === row.id && (
                    <>
                      <TableRow>
                        <TableCell colSpan={4} style={{ padding: "15px" }}>
                          <Box display="flex" flexWrap="wrap" gap={2}>
                            {row.metrics.map((metric, i) => (
                              <Box key={i} className="small_card form" style={{ width: 'calc(100% / 4 - (16px * 3 / 4))', gap: '5px' }}>
                                <b style={{ fontSize: '14px' }}>{metric}</b>

                                <TextField
                                  size="small"
                                  type="number"
                                  placeholder="Score %"
                                  fullWidth
                                />
                              </Box>
                            ))}
                          </Box>
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <SetHealthScore
        open={openModal}
        onClose={() => setOpenModal(false)}
        setOpen={setOpenModal}
      />
    </>
  );
}

export default ManageAutomation;